import { html } from "lit";
import '../tabs/Skills/skills';
import '../tabs/Projects/projects';
import '../tabs/Contact/contact';
import "../tabs/Settings/settings";
import '../tabs/Intro/intro';
import UIkit from "uikit";

const navSettings = [
  {
    id: 0,
    href: ""
  },
  {
    id: 1,
    href: "#skills"
  },
  {
    id: 2,
    href: "#projects"
  },
  {
    id: 3,
    href: "#contact"
  },
  {
    id: 4,
    href: "#settings"
  }
];
const currentHash = window.location.hash;
const currentTabSettings = (currentHash && currentHash.length) ?
  (navSettings.find(elem => elem.href === currentHash)) : navSettings[0];
let activeTab = (currentTabSettings === undefined) ? navSettings[0].id : currentTabSettings.id;
let darkMode = (localStorage.getItem("darkModeOn") === "true")
let isDarkModeSetBefore = !!localStorage.getItem("darkModeOn")

const updateUrl = (e) => {
  if (!e.target.parentElement) return;
  window.location.hash = e.target.closest("a").getAttribute("href");
}
window.addEventListener('hashchange', function(e){
  const updatedTabSettings = (navSettings.find(elem => elem.href === (window.location.hash)))
  activeTab = (updatedTabSettings === undefined) ? navSettings[0].id : updatedTabSettings.id;
  UIkit.switcher(".navigation").show(activeTab);
});

function updateDarkModeState(e) {
  darkMode = e.detail.value
  if (darkMode) {
    document.querySelector("html").style.backgroundColor = "transparent"
    document.querySelector("body").classList.add("dark-mode")
  } else {
    document.querySelector("html").style.backgroundColor = "#f5f4f1"
    document.querySelector("body").classList.remove("dark-mode")
  }
}
updateDarkModeState({detail: {value: darkMode }})


if (!isDarkModeSetBefore && window.matchMedia) {
  // Check if the dark-mode Media-Query matches
  if(window.matchMedia('(prefers-color-scheme: dark)').matches){
    // Dark
    updateDarkModeState({detail: {value: true}})
  }
}

const template = html`
        <div>
            <div class="body__wr uk-container uk-container-large uk-margin-auto">
                <ul uk-switcher="connect: #tabs; active: ${activeTab}; hash: true" class="navigation">
                    <li class="list intro" @click="${updateUrl}">
                        <a href="" data-uk-switcher-item="0" class="list--link">
                            <span class="icon">
                                <span uk-icon="home"></span>
                            </span>
                        </a>
                    </li>
                    <li class="list skills" @click="${updateUrl}">
                        <a href="#skills" data-uk-switcher-item="1" class="list--link">
                            <span class="icon">
                                   <span uk-icon="user"></span>
                            </span>
                        </a>
                    </li>
                    <li class="list projects" @click="${updateUrl}">
                        <a href="#projects" data-uk-switcher-item="2" class="list--link">
                            <span class="icon">
                                <span uk-icon="code"></span>
                            </span>
                        </a>
                    </li>
                    <li class="list contact" @click="${updateUrl}">
                        <a href="#contact" data-uk-switcher-item="3" class="list--link">
                            <span class="icon">
                                <span uk-icon="mail"></span>
                            </span>
                        </a>
                    </li>
                    <li class="list settings" @click="${updateUrl}">
                        <a href="#settings" data-uk-switcher-item="4" class="list--link">
                            <span class="icon">
                                   <span uk-icon="cog"></span>
                            </span>
                        </a>
                    </li>
                    <div class="indicator"></div>
                </ul>
                <ul id="tabs" class="uk-switcher tab-content"">
                    <li class="intro-tab">
                        <div class="intro-tab--inner">
                            <intro-tab></intro-tab>                           
                        </div>
                    </li>
                    <li class="skills-tab">
                        <skills-tab></skills-tab>
                    </li>
                    <li class="projects-tab">
                        <projects-tab></projects-tab>
                    </li>
                    <li class="contact-tab">
                        <contact-tab></contact-tab>
                    </li>
                    <li class="settings-tab">
                       <settings-tab @my-event="${updateDarkModeState}"></settings-tab>     
                    </li>
                </ul>
            </div>
            <div class="version-badge">${__APP_VERSION__}</div>
        </div>
`;

const litHtmlTemplate = template;
export default litHtmlTemplate;

